import { success, error as requestError } from '@redux-requests/core';
import { put, race, take, delay } from 'redux-saga/effects';

import { fetchDifferences } from './actions';

export const DIFFERENCES_REFETCH_TIMEOUT_MS = 10000;

/**
 * Refetches the differences and waits for the response to land. The refetch replaces the whole
 * differences array with server state, so it has to settle before thumbnails are generated —
 * otherwise a late response reverts thumbnail URLs that had already arrived.
 *
 * A timeout only warns instead of throwing, so a slow refetch degrades to carrying on rather than
 * abandoning the rest of the merge.
 */
export function* refetchDifferencesAndWait(inspectionId: string) {
  yield put(fetchDifferences(inspectionId));

  const outcome: { succeeded?: unknown; failed?: unknown; timedOut?: unknown } = yield race({
    succeeded: take(success(fetchDifferences.toString())),
    failed: take(requestError(fetchDifferences.toString())),
    timedOut: delay(DIFFERENCES_REFETCH_TIMEOUT_MS),
  });

  if (outcome.failed) {
    throw new Error('Differences refetch failed after merge');
  }

  if (outcome.timedOut) {
    console.warn('Timed out waiting for the differences refetch after merge; continuing.');
  }
}
